
    import Vue from "vue";
    import {Component, Prop} from "vue-property-decorator";
    import Modal from "../UI/Modal.vue";
    import VueButton from "../UI/VueButton.vue";
    import Cross from "@/Icons/Cross.vue";
    import Tick from "@/Icons/Tick.vue";
    import {CompletedQuestion, ICompletedCategoryQuestion} from "@/Core/Interactions";

    @Component({
        components: {
            Tick,
            Cross,
            Modal,
            VueButton
        }
    })
    export default class ResultModal extends Vue {
        @Prop({required: true, type: Object}) completedQuestion: CompletedQuestion;

        continueTutorial() {
            this.$emit("continue");
        }

        close() {
            this.$emit("close");
        }

        isCorrect(answerCode: string) {
            let cq = <ICompletedCategoryQuestion> this.completedQuestion;
            return cq.givenAnswers.find(a => a.questionAnswerCode === answerCode)!.isCorrect;
        }

        get hasIndividualAnswerFeedback() {
            if (this.completedQuestion.questionType !== "category")
                return false;

            for (let x of this.completedQuestion.correctAnswers) {
                let y = <any> x;
                if (y.answerFeedback)
                    return true;
            }

            return false;
        }
    }
